<util-progress [bar]="true" *ngIf="loading"></util-progress>
<div class="post-last-step-gallery mb-3">
  <div class="mb-3">
    <div class="p-2" *ngIf="existingImages && existingImages.length > 0">
      <small class="muted">Images</small><br />
      <div
        class="image-container d-inline-block position-relative m-1"
        *ngFor="let ei of existingImages">
        <img
          class="avatar-md border rounded object-fit-cover"
          src="{{ei.thumb_url}}"
          alt=""
          (click)="removeExImage($event, ei)"
        />
        <button
          class="close-button btn btn-danger btn-sm position-absolute"
          (click)="removeExImage($event, ei)"
          aria-label="Remove image">
          ×
        </button>
      </div>
    </div>

  </div>

  <label class="form-label">{{ title }}</label>
  <div class="input-group mb-3">
    <label for="image-upload"><i class="flaticon-add"></i></label>
    <input type="file" class="form-control" id="image-upload" (click)="onPickerClicked($event)">
  </div>
  <small class="mt-1 text-info" *ngIf="msg.length>0">{{ msg }}</small>
</div>
<util-progress [bar]="true" *ngIf="loading"></util-progress>
